<template>
  <RotateFrame>
  <div id="withdraw-root" class="withdraw-root">
    <!-- 1. 顶部栏 (Header) -->
    <div class="header">
      <img class="left-icon" src="/assets/arrow_left.png" @click="exit">
      <span class="title">Withdraw</span>
      <span class="placeholder"></span>
    </div>

    <div class="withdraw-content">
      <!-- 横屏左栏 / 竖屏顶部：balance + tabs -->
      <div class="content-left">
        <!-- 2. 余额卡片 (Balance Card) -->
        <!-- 背景图放在 public，用内联 style 引用，避免 css-loader 去解析 /assets 绝对路径 -->
        <div class="balance-card" :style="balanceCardStyle">
          <div class="total-balance">
            <div class="total-balance-1">
              <div class="balance-font">Withdrawable Amount</div>
              <img class="history-button" src="/assets/withdraw-us/history-button.png" @click="toHistory" />
            </div>
            <div class="balance-am">${{realBalance}}</div>
          </div>

          <div class="ba-line"></div>

          <div class="ba-withdrawable-amount">
            <div class="ba-withdrawable-amount-font">Total Balance</div>
            <div class="ba-withdrawable-amount-am">${{showBalance}}</div>
          </div>
        </div>

        <!-- 3. 标签页导航 (Tabs) -->
        <div class="tabs-container">
          <div class="tab-item" :class="{ active: tabType === CARD_TYPE }" @click="switchTab(CARD_TYPE)" v-if="showCardTab">
            Card
          </div>
          <div class="tab-item" :class="{ active: tabType === 3 }" @click="switchTab(3)">
            PayPal
          </div>
          <div class="tab-item" :class="{ active: tabType === 4 }" @click="switchTab(4)" v-if="withCheck.usdt_withdraw_show">
            USDT
          </div>
        </div>
      </div><!-- /.content-left -->

      <!-- 横屏右栏 / 竖屏下部：account + input + button -->
      <div class="content-right">
        <div id="paypal-root" v-if="tabType === 3">
          <div class="account-section">
            <h3 class="section-title">Select PayPal Account</h3>
            <div class="account-card" v-if="!paypalAccountList || paypalAccountList.length === 0">
              <img src="/assets/withdraw-us/paypal-icon.png" alt="paypal" class="paypal-icon" />
              <p class="no-address-text">You haven't added a PayPal account yet.</p>
              <button class="add-btn" @click="openOTPVerify(1)">+ Add now</button>
            </div>
            <div class="current-paypal-container" v-else @click="selectPaypal">
              <div class="current-paypal-container-left">
                <img class="sm-paypal" src="/assets/withdraw-us/sm-paypal.png" />
                <span v-if="currentPaypal && currentPaypal.bankCardNumber">{{formatEmail(currentPaypal.bankCardNumber)}}</span>
                <span v-else>Choice your account</span>
              </div>
              <img class="arrow-right" src="/assets/withdraw-us/arrow-right.png" />
            </div>
            <p class="account-tips" v-if="paypalAccountList && paypalAccountList.length > 0 && !(currentPaypal && currentPaypal.bankCardNumber)">Select a withdrawal account.</p>
          </div>

          <!-- 5. 提现金额输入区 (Withdrawal Amount Input) -->
          <div class="input-section">
            <h3 class="section-title">Withdrawal Amount</h3>
            <div class="input-box amount-box" :class="{ invalid: amountError }">
              <span class="prefix" v-if="amountInput !== ''">$</span>
              <input @keydown.enter="finish" :value="amountInput" @input="handleAmountInput" type="text" inputmode="decimal" placeholder="Enter withdrawal amount" class="amount-input" />
              <button class="max-btn" :disabled="!maxEnabled" @click="fillMax">Max</button>
            </div>
            <div class="amount-error" v-if="amountError">{{amountError}}</div>
            <div class="rule-line" v-for="line in ruleLines" :key="line">{{line}}</div>
            <div class="limit-alert" v-if="limitAlert">
              <img src="/assets/withdraw-us/warning-tips.png" class="limit-alert-icon" />
              <span class="limit-alert-text">{{limitAlert}}</span>
              <button class="limit-retry" v-if="checkFailed || balanceFailed" @click="retryLoad">Retry</button>
            </div>
          </div>

          <!-- 6. 实收金额区 (Receive Amount) -->
          <div class="receive-section">
            <div class="receive-row">
              <span class="limit-label">Receive amount</span>
              <span class="limit-value">{{receiveText}}</span>
            </div>
          </div>
          <!-- 7. 底部提现按钮 (Bottom Button) -->
          <div class="bottom-action">
            <button class="withdraw-btn" :class="{ active: paypalCanWithdraw }" :disabled="!paypalCanWithdraw" @click="clickWithdraw">Withdraw</button>
          </div>

          <!-- 蒙层 -->
          <div v-if="verifyOTPFlag || addPaypalFlag || selectPaypalFlag || clickWithdrawFlag || addUSDTFlag || selectUSDTFlag" class="drawer-mask" @click="closeVerify"></div>

          <!-- 抽屉：OTP 验证 -->
          <transition name="drawer-up">
            <div v-if="verifyOTPFlag" class="drawer-high">
              <div class="drawer-header">
                <img src="/assets/arrow_left.png" class="back" @click="closeVerify">
                <div class="title">Account verification</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <!-- 邮箱登录展示邮箱验证，手机登录展示手机号验证 -->
                  <template v-if="isEmailVerify">
                    <div class="label-1">Email address</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/email.png" alt="email-icon" class="input-icon"/>
                      <div class="mobiletext">{{verifyEmail}}</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="label-1">Phone number</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/mobile-icon.png" alt="mobile-icon" class="input-icon"/>
                      <span class="input-span">+1</span>
                      <div class="mobiletext">{{singleMobile}}</div>
                    </div>
                  </template>
                </div>

                <div class="form-item">
                  <div class="label-1">OTP</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" v-model="otp" type="text" placeholder="Enter your OTP" inputmode="numeric" maxlength="4" oninput="this.value = this.value.replace(/\D/g, '').slice(0,4)">
                    <button class="otp-btn" :disabled="countdown > 0" @click="getOtp">
                      {{ countdown > 0 ? `${countdown}s` : 'Get OTP' }}
                    </button>
                  </div>
                  <div class="otp-wrong" v-if="otpfailed">
                    <img src="/assets/withdraw-us/warning-tips.png" class="warning-tips" />
                    <span>OTP error,please try again</span>
                  </div>
                  <!-- 邮箱验证码常被投递到垃圾邮件，提示用户去 Spam/Junk 里找；发送后高亮 -->
                  <div class="email-tips" :class="{ sent: otpSent }" v-if="isEmailVerify">
                    <img class="email-tips-icon" :src="otpSent ? emailSentIcon : emailUnsentIcon" alt="email-tips" />
                    <div class="email-tips-text">
                      <div class="email-tips-title">Can't find the email?</div>
                      <div class="email-tips-desc">Check your <span>Spam</span> or <span>Junk</span> folder.</div>
                    </div>
                  </div>
                </div>

                <button class="verify-btn" :class="{ active: canVerify }" :disabled="!canVerify" @click="verifyOtp">
                  Verify
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：新增 PayPal -->
          <transition name="drawer-up">
            <div v-if="addPaypalFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Add Paypal Account</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="label-1">PayPal Account(Email Address)</div>
                  <div class="input-box">
                    <img src="/assets/withdraw-us/email.png" alt="mobile-icon" class="input-icon-email"/>
                    <input @keydown.enter="finish" v-model="currentEmail" type="email" placeholder="Enter your email address" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$" />
                  </div>
                  <div class="label-tips">
                    <img class="add-tips" src="/assets/withdraw-us/add-tips.png" alt="add-tips" />
                    <span>Please make sure the email address your enter is correct and accessible.</span>
                  </div>
                </div>

                <button class="confirm-btn" :class="{ active: canAddPaypal }" :disabled="!canAddPaypal" @click="toAddPaypal">
                  confirm
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：选择 PayPal -->
          <transition name="drawer-up">
            <div v-if="selectPaypalFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Select PayPal Account</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="list-paypal-container" v-for="(item, index) in paypalAccountList" :key="index" @click="selectPaypal(item, index)">
                    <div class="current-paypal-container-left">
                      <img class="sm-paypal" src="/assets/withdraw-us/sm-paypal.png" />
                      <span>{{ formatEmail(item.bankCardNumber) }}</span>
                    </div>
                    <div class="right-action">
                      <img class="del-icon" src="/assets/withdraw-us/del.png" @click.stop="doDelPaypal(item)" />
                      <img v-if="currentPaypal && item.bankCardNumber === currentPaypal.bankCardNumber" class="select-account-right" src="/assets/withdraw-us/list-right.png" />
                      <img v-else class="select-account-right" src="/assets/withdraw-us/list-no-right.png" @click="choicePaypalItem(item)" />
                    </div>
                  </div>
                  <div class="selectAddPaypalContainer" @click="openOTPVerifyCloseSelect(1)">
                    <div class="current-paypal-container-left">
                      <img class="sm-paypal" src="/assets/withdraw-us/add.png" />
                      <span style="color: #4625BB">Add new PayPal Account</span>
                    </div>
                    <img class="select-account-right-2" src="/assets/withdraw-us/b-arrow-right.png" />
                  </div>
                </div>

                <button class="confirm-btn active" @click="closeVerify">
                  confirm
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：提现确认 -->
          <transition name="drawer-up">
            <div v-if="clickWithdrawFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Withdrawal Confirmation</div>
              </div>
              <div class="drawer-body">
                <div class="withdraw-form-item">
                  <div class="withdraw-form-label1">
                    <div class="withdraw-form-label-l">
                      <img class="withdraw-form-icon" src="/assets/withdraw-us/sm-paypal.png" />
                      <div class="withdraw-form-label1-2">
                        <span>PayPal Account</span>
                        <span style="font-size: .32rem; font-weight: bold">{{currentPaypal.bankCardNumber}}</span>
                      </div>
                    </div>
                    <img class="green-right" src="/assets/withdraw-us/green-right.png" />
                  </div>

                  <div class="form-line"></div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Withdrawal Amount</span>
                    <span class="withdraw-form-a-2">{{receiveText}}</span>
                  </div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Receive Amount</span>
                    <span class="withdraw-form-a-2" style="margin-bottom: .3rem">{{receiveText}}</span>
                  </div>
                </div>

                <div class="confirm-btn-2-group">
                  <div class="sec">
                    <img src="/assets/withdraw-us/sec-icon.png" class="sec-icon" />
                    <span class="sec-span">SECURE ENCRYPTED TRANSACTION</span>
                  </div>
                  <button class="confirm-btn-2 active" @click="startWithdraw">
                    confirm
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div id="usdt-root" v-if="tabType === 4">
          <!-- 4. 账户选择区 (Account Selection) -->
          <div class="account-section">
            <h3 class="section-title">Select USDT Account</h3>
            <div class="account-card" v-if="!addressList || addressList.length === 0">
              <img src="/assets/withdraw-us/usdt-icon.png" alt="paypal" class="usdt-icon" />
              <p class="no-address-text">No wallet address available</p>
              <button class="add-btn" @click="openOTPVerify(4)">+ Add now</button>
            </div>
            <div class="current-paypal-container" v-else @click="selectUSDT">
              <div class="current-paypal-container-left" v-if="currentAddress">
                <img class="sm-paypal" src="/assets/withdraw-us/usdt-icon.png" />
                <span>{{displayAddress}}</span>
              </div>
              <div class="current-paypal-container-left" v-else>
                <span>Choice your address</span>
              </div>
              <img class="arrow-right" src="/assets/withdraw-us/arrow-right.png" />
            </div>
          </div>

          <!-- 5. 提现金额输入区 (Withdrawal Amount Input) -->
          <div class="input-section">
            <h3 class="section-title">Withdrawal Amount</h3>
            <div class="input-box">
              <span class="prefix">$</span>
              <input @keydown.enter="finish" :value="usdtAmount" @input="handleInput" type="number" placeholder="Please enter the withdrawal amount" class="amount-input" />
            </div>

            <div class="usdt_amount_warning_tips" v-if="usdtAmount && insufficientAmount">
              <img src="/assets/withdraw-us/warning-tips.png" alt="paypal" class="usdt-icon2" />
              <div class="usdt_a_tips">Insufficient available balance</div>
            </div>
            <div class="usdt_amount_warning_tips" v-else-if="usdtAmount && leastMinAmount">
              <img src="/assets/withdraw-us/warning-tips.png" alt="paypal" class="usdt-icon2" />
              <div class="usdt_a_tips">Withdrawal must be at least ${{minAmount}}.</div>
            </div>
            <div class="usdt_amount_warning_tips" v-else-if="usdtAmount && usdtMaxAmountWarningTips">
              <img src="/assets/withdraw-us/warning-tips.png" alt="paypal" class="usdt-icon2" />
              <div class="usdt_a_tips">Withdrawal cannot exceed ${{maxAmount}}.</div>
            </div>

            <div class="limit-row">
              <span class="limit-label">Cash withdrawal limit</span>
              <span class="limit-value">${{formattedAmount(minAmount)}} - ${{formattedAmount(maxAmount)}}</span>
            </div>
          </div>

          <!-- 6. 实收金额区 (Receive Amount) -->
          <div class="receive-section">
            <div class="receive-row">
              <span class="limit-label">Receive amount</span>
              <span class="limit-value">${{receiveUsdtAmount}}</span>
            </div>
          </div>
          <!-- 7. 底部提现按钮 (Bottom Button) -->
          <div class="bottom-action">
            <button class="withdraw-btn" :class="{ active: usdtCanWithdraw }" :disabled="!usdtCanWithdraw" @click="clickUsdtWithdraw">Withdraw</button>
          </div>

          <!-- 蒙层 -->
          <div v-if="verifyOTPFlag || addPaypalFlag || selectPaypalFlag || clickWithdrawFlag || addUSDTFlag || selectUSDTFlag || clickUSDTWithdrawFlag" class="drawer-mask" @click="closeVerify"></div>

          <!-- 抽屉：OTP 验证 -->
          <transition name="drawer-up">
            <div v-if="verifyOTPFlag" class="drawer-high">
              <div class="drawer-header">
                <img src="/assets/arrow_left.png" class="back" @click="closeVerify">
                <div class="title">Account verification</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <!-- 邮箱登录展示邮箱验证，手机登录展示手机号验证 -->
                  <template v-if="isEmailVerify">
                    <div class="label-1">Email address</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/email.png" alt="email-icon" class="input-icon"/>
                      <div class="mobiletext">{{verifyEmail}}</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="label-1">Phone number</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/mobile-icon.png" alt="mobile-icon" class="input-icon"/>
                      <span class="input-span">+1</span>
                      <div class="mobiletext">{{singleMobile}}</div>
                    </div>
                  </template>
                </div>

                <div class="form-item">
                  <div class="label-1">OTP</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" v-model="otp" type="text" placeholder="Enter your OTP" inputmode="numeric" maxlength="4" oninput="this.value = this.value.replace(/\D/g, '').slice(0,4)">
                    <button class="otp-btn" :disabled="countdown > 0" @click="getOtp">
                      {{ countdown > 0 ? `${countdown}s` : 'Get OTP' }}
                    </button>
                  </div>
                  <div class="otp-wrong" v-if="otpfailed">
                    <img src="/assets/withdraw-us/warning-tips.png" class="warning-tips" />
                    <span>OTP error,please try again</span>
                  </div>
                  <!-- 邮箱验证码常被投递到垃圾邮件，提示用户去 Spam/Junk 里找；发送后高亮 -->
                  <div class="email-tips" :class="{ sent: otpSent }" v-if="isEmailVerify">
                    <img class="email-tips-icon" :src="otpSent ? emailSentIcon : emailUnsentIcon" alt="email-tips" />
                    <div class="email-tips-text">
                      <div class="email-tips-title">Can't find the email?</div>
                      <div class="email-tips-desc">Check your <span>Spam</span> or <span>Junk</span> folder.</div>
                    </div>
                  </div>
                </div>

                <button class="verify-btn" :class="{ active: canVerify }" :disabled="!canVerify" @click="verifyOtp">
                  Verify
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：新增钱包地址 -->
          <transition name="drawer-up">
            <div v-if="addUSDTFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Add Wallet Address</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="label-1">Address</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" v-model="inputAddress" type="text" placeholder="Enter or paste the address" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$" />
                  </div>

                  <div class="form-item">
                    <div class="label-1">Upload image</div>
                    <div class="upload-container">
                      <div v-if="!uploadImageUrl" class="upload-placeholder" @click="triggerUpload">
                        <img src="/assets/withdraw-us/upload-icon.png" alt="upload" />
                        <span>Click to upload</span>
                      </div>
                      <div v-else class="upload-preview" @click="triggerUpload">
                        <img :src="uploadImageUrl" class="preview-img" />
                        <div class="remove-btn" @click="removeImage">
                          <img src="/assets/withdraw-us/remove-icon.png" alt="remove" />
                        </div>
                      </div>
                      <input ref="fileInput" type="file" accept="image/*" style="display: none" @change="handleFileChange" />
                    </div>
                  </div>

                  <div class="label-tips">
                    <img class="add-tips" src="/assets/withdraw-us/add-tips.png" alt="add-tips" />
                    <span>
                      Upload a QR code image of your wallet address
                      to verify the correctness of the transaction
                      address.
                    </span>
                  </div>
                </div>

                <button class="confirm-btn-3" :class="{ active: canAddUSDT }" :disabled="!canAddUSDT" @click="toAddUSDT">
                  Add Address
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：选择钱包地址 -->
          <transition name="drawer-up">
            <div v-if="selectUSDTFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Select Wallet Address</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="list-paypal-container" v-for="(item, index) in addressList" :key="index" @click="selectUSDT(item, index)">
                    <div class="current-paypal-container-left">
                      <img class="sm-paypal" src="/assets/withdraw-us/sm-paypal.png" />
                      <span>{{ formatedDisplayAddress(item.usdtAddress) }}</span>
                    </div>
                    <div class="right-action">
                      <img class="del-icon" src="/assets/withdraw-us/del.png" @click.stop="doDelUSDT(item)" />
                      <img v-if="item.usdtAddress === currentAddress" class="select-account-right" src="/assets/withdraw-us/list-right.png" />
                      <img v-else class="select-account-right" src="/assets/withdraw-us/list-no-right.png" @click="choiceUSDTItem(item)" />
                    </div>
                  </div>
                  <div class="selectAddPaypalContainer" @click="openOTPVerifyCloseSelect(4)">
                    <div class="current-paypal-container-left">
                      <img class="sm-paypal" src="/assets/withdraw-us/add.png" />
                      <span style="color: #4625BB">Add Wallet Address</span>
                    </div>
                    <img class="select-account-right-2" src="/assets/withdraw-us/b-arrow-right.png" />
                  </div>
                </div>

                <button class="confirm-btn active" @click="closeVerify">
                  confirm
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：USDT 提现确认 -->
          <transition name="drawer-up">
            <div v-if="clickUSDTWithdrawFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Withdrawal Confirmation</div>
              </div>
              <div class="drawer-body">
                <div class="withdraw-form-item">
                  <div class="withdraw-form-label1">
                    <div class="withdraw-form-label-l">
                      <img class="withdraw-form-icon" src="/assets/withdraw-us/usdt-icon.png" />
                      <div class="withdraw-form-label1-2">
                        <span>{{displayAddress}}</span>
                        <div class="tron-line">
                          <span>Tron</span>
                          <div class="trc20">TRC20</div>
                        </div>
                      </div>
                    </div>
                    <img class="green-right" src="/assets/withdraw-us/green-right.png" />
                  </div>

                  <div class="form-line"></div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Withdrawal Amount</span>
                    <span class="withdraw-form-a-2">${{usdtAmount}}</span>
                  </div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Receive Amount</span>
                    <span class="withdraw-form-a-2" style="margin-bottom: .3rem">${{receiveUsdtAmount}}USDT</span>
                  </div>
                </div>

                <div class="confirm-btn-2-group">
                  <div class="sec">
                    <img src="/assets/withdraw-us/sec-icon.png" class="sec-icon" />
                    <span class="sec-span">SECURE ENCRYPTED TRANSACTION</span>
                  </div>
                  <button class="confirm-btn-2 active" @click="startUSDTWithdraw">
                    confirm
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div id="card-root" v-if="tabType === CARD_TYPE">
          <!-- 账户选择区 -->
          <div class="account-section">
            <h3 class="section-title">Select Card</h3>
            <div class="account-card" v-if="!cardList || cardList.length === 0">
              <span class="card-brand-icon big-card-icon"></span>
              <p class="no-address-text">You haven't added a Card yet.</p>
              <button class="add-btn" @click="openOTPVerify(6)">+ Add now</button>
            </div>
            <div class="current-paypal-container" v-else @click="selectCard">
              <div class="current-paypal-container-left">
                <span class="card-brand-icon"></span>
                <span v-if="currentCard.bankCardNumber">{{formatCard(currentCard.bankCardNumber)}}</span>
                <span v-else>Choice your card</span>
              </div>
              <img class="arrow-right" src="/assets/withdraw-us/arrow-right.png" />
            </div>
            <p class="account-tips" v-if="cardList && cardList.length > 0 && !currentCard.bankCardNumber">Select a withdrawal account.</p>
          </div>

          <!-- 提现金额输入区，阶梯与 PayPal 共用 -->
          <div class="input-section">
            <h3 class="section-title">Withdrawal Amount</h3>
            <div class="input-box amount-box" :class="{ invalid: amountError }">
              <span class="prefix" v-if="amountInput !== ''">$</span>
              <input @keydown.enter="finish" :value="amountInput" @input="handleAmountInput" type="text" inputmode="decimal" placeholder="Enter withdrawal amount" class="amount-input" />
              <button class="max-btn" :disabled="!maxEnabled" @click="fillMax">Max</button>
            </div>
            <div class="amount-error" v-if="amountError">{{amountError}}</div>
            <div class="rule-line" v-for="line in ruleLines" :key="line">{{line}}</div>
            <div class="limit-alert" v-if="limitAlert">
              <img src="/assets/withdraw-us/warning-tips.png" class="limit-alert-icon" />
              <span class="limit-alert-text">{{limitAlert}}</span>
              <button class="limit-retry" v-if="checkFailed || balanceFailed" @click="retryLoad">Retry</button>
            </div>
          </div>

          <div class="receive-section">
            <div class="receive-row">
              <span class="limit-label">Receive amount</span>
              <span class="limit-value">{{receiveText}}</span>
            </div>
          </div>
          <!-- 底部提现按钮 -->
          <div class="bottom-action">
            <button class="withdraw-btn" :class="{ active: cardCanWithdraw }" :disabled="!cardCanWithdraw" @click="clickCardWithdraw">Withdrawal</button>
          </div>

          <!-- 蒙层 -->
          <div v-if="verifyOTPFlag || addCardFlag || selectCardFlag || clickCardWithdrawFlag" class="drawer-mask" @click="closeVerify"></div>

          <!-- 抽屉：OTP 验证 -->
          <transition name="drawer-up">
            <div v-if="verifyOTPFlag" class="drawer-high">
              <div class="drawer-header">
                <img src="/assets/arrow_left.png" class="back" @click="closeVerify">
                <div class="title">Account verification</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <!-- 邮箱登录展示邮箱验证，手机登录展示手机号验证 -->
                  <template v-if="isEmailVerify">
                    <div class="label-1">Email address</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/email.png" alt="email-icon" class="input-icon"/>
                      <div class="mobiletext">{{verifyEmail}}</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="label-1">Phone number</div>
                    <div class="noinput-box">
                      <img src="/assets/withdraw-us/mobile-icon.png" alt="mobile-icon" class="input-icon"/>
                      <span class="input-span">+1</span>
                      <div class="mobiletext">{{singleMobile}}</div>
                    </div>
                  </template>
                </div>

                <div class="form-item">
                  <div class="label-1">OTP</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" v-model="otp" type="text" placeholder="Enter your OTP" inputmode="numeric" maxlength="4" oninput="this.value = this.value.replace(/\D/g, '').slice(0,4)">
                    <button class="otp-btn" :disabled="countdown > 0" @click="getOtp">
                      {{ countdown > 0 ? `${countdown}s` : 'Get OTP' }}
                    </button>
                  </div>
                  <div class="otp-wrong" v-if="otpfailed">
                    <img src="/assets/withdraw-us/warning-tips.png" class="warning-tips" />
                    <span>OTP error,please try again</span>
                  </div>
                  <!-- 邮箱验证码常被投递到垃圾邮件，提示用户去 Spam/Junk 里找；发送后高亮 -->
                  <div class="email-tips" :class="{ sent: otpSent }" v-if="isEmailVerify">
                    <img class="email-tips-icon" :src="otpSent ? emailSentIcon : emailUnsentIcon" alt="email-tips" />
                    <div class="email-tips-text">
                      <div class="email-tips-title">Can't find the email?</div>
                      <div class="email-tips-desc">Check your <span>Spam</span> or <span>Junk</span> folder.</div>
                    </div>
                  </div>
                </div>

                <button class="verify-btn" :class="{ active: canVerify }" :disabled="!canVerify" @click="verifyOtp">
                  Verify
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：新增银行卡 -->
          <transition name="drawer-up">
            <div v-if="addCardFlag" class="drawer">
              <div class="drawer-header">
                <img src="/assets/arrow_left.png" class="back" @click="closeVerify">
                <div class="title">Add Card</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="label-1">Enter card number</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" :value="cardNumber" @input="handleCardNumberInput" type="text" inputmode="numeric" placeholder="Enter card number" maxlength="30" />
                    <!-- 认出卡组织就显示，认不出不拦截 -->
                    <span class="card-brand-text" v-if="cardBrand">{{cardBrand}}</span>
                  </div>
                </div>

                <div class="form-item">
                  <div class="label-1">Expiration Date</div>
                  <div class="input-box">
                    <input @keydown.enter="finish" :value="cardExpiry" @input="handleCardExpiryInput" type="text" inputmode="numeric" placeholder="MM/YY" maxlength="5" />
                  </div>
                </div>

                <div class="label-tips">
                  <img class="add-tips" src="/assets/withdraw-us/add-tips.png" alt="add-tips" />
                  <span>Card information is required to process your withdrawal securely.</span>
                </div>

                <button class="confirm-btn" :class="{ active: canAddCard }" :disabled="!canAddCard" @click="toAddCard">
                  Save Card
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：选择银行卡 -->
          <transition name="drawer-up">
            <div v-if="selectCardFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Select Card</div>
              </div>
              <div class="drawer-body">
                <div class="form-item">
                  <div class="list-paypal-container" v-for="(item, index) in cardList" :key="index" @click="selectCard(item, index)">
                    <div class="current-paypal-container-left">
                      <span class="card-brand-icon"></span>
                      <span>{{ formatCard(item.bankCardNumber) }}</span>
                    </div>
                    <div class="right-action">
                      <img class="del-icon" src="/assets/withdraw-us/del.png" @click.stop="doDelCard(item)" />
                      <img v-if="item.bankCardNumber === currentCard.bankCardNumber" class="select-account-right" src="/assets/withdraw-us/list-right.png" />
                      <img v-else class="select-account-right" src="/assets/withdraw-us/list-no-right.png" @click="choiceCardItem(item)" />
                    </div>
                  </div>
                  <div class="selectAddPaypalContainer" @click="openOTPVerifyCloseSelect(6)">
                    <div class="current-paypal-container-left">
                      <img class="sm-paypal" src="/assets/withdraw-us/add.png" />
                      <span style="color: #4625BB">Add new Card</span>
                    </div>
                    <img class="select-account-right-2" src="/assets/withdraw-us/b-arrow-right.png" />
                  </div>
                </div>

                <button class="confirm-btn active" @click="closeVerify">
                  confirm
                </button>
              </div>
            </div>
          </transition>

          <!-- 抽屉：提现确认 -->
          <transition name="drawer-up">
            <div v-if="clickCardWithdrawFlag" class="drawer">
              <div class="drawer-header">
                <div class="title">Withdrawal Confirmation</div>
              </div>
              <div class="drawer-body">
                <div class="withdraw-form-item">
                  <div class="withdraw-form-label1">
                    <div class="withdraw-form-label-l">
                      <span class="card-brand-icon withdraw-form-card-icon"></span>
                      <div class="withdraw-form-label1-2">
                        <span>Card</span>
                        <span style="font-size: .32rem; font-weight: bold">{{currentCard.bankCardNumber}}</span>
                      </div>
                    </div>
                    <img class="green-right" src="/assets/withdraw-us/green-right.png" />
                  </div>

                  <div class="form-line"></div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Withdrawal Amount</span>
                    <span class="withdraw-form-a-2">{{receiveText}}</span>
                  </div>

                  <div class="withdraw-form-a">
                    <span class="withdraw-form-a-1">Receive Amount</span>
                    <span class="withdraw-form-a-2" style="margin-bottom: .3rem">{{receiveText}}</span>
                  </div>
                </div>

                <div class="confirm-btn-2-group">
                  <div class="sec">
                    <img src="/assets/withdraw-us/sec-icon.png" class="sec-icon" />
                    <span class="sec-span">SECURE ENCRYPTED TRANSACTION</span>
                  </div>
                  <button class="confirm-btn-2 active" @click="startCardWithdraw">
                    confirm
                  </button>
                </div>
              </div>
            </div>
          </transition>

          <!-- 弹窗：加卡失败 -->
          <div v-if="addCardFailFlag" class="fail-mask" @click="addCardFailFlag = false">
            <div class="fail-dialog" @click.stop>
              <img class="fail-icon" src="@/assets/ic_warn.png" alt="warn" />
              <div class="fail-title">Add Card failed.</div>
              <div class="fail-desc">Failed to add card. Please try again.</div>
              <button class="fail-btn" @click="addCardFailFlag = false">Back</button>
            </div>
          </div>
        </div>
      </div><!-- /.content-right -->
    </div>
  </div>
  </RotateFrame>
</template>

<script>
import { postRequest, getRequest, formPostRequest, reportBuriedPointRequest, isRequestFailed, toast } from '@/utils/withdrawApi'
import bus from 'vue3-eventbus'
import withdrawRem from './withdrawRem'
import RotateFrame from './RotateFrame.vue'
import emailSentIcon from '@/assets/iv_email_send.png'
import emailUnsentIcon from '@/assets/iv_email_unsend.png'

export default {
  components: { RotateFrame },
  mixins: [withdrawRem],
  data () {
    return {
      network_fee: null,
      usdtAmount: null,
      inputAddress: null,
      realBalance: null,
      showBalance: null,
      showUsdtTab: false,
      paypalAccountList: null,
      currentEmail: '',
      singleMobile: '',
      otp: null,
      mobile: null,
      verifyOTPFlag: false,
      addPaypalFlag: false,
      selectPaypalFlag: false,
      code: '',
      aid: '',
      type: 'daily',
      start: '',
      end: '',
      params: '',
      datelines: [],
      rankList: [],
      datelineClass: 'datelinePitch',
      page: 1,
      tabType: 3,
      total: 5,
      isNot: false,
      currentPaypal: {},
      countdown: 0,
      deletePaypalId: null,
      isShow: 0,
      selectUSDTFlag: false,
      isShowMy: false,
      isShowOther: false,
      isShowDesc: false,
      isShowShare: true,
      version: '',
      appInfo: {},
      isInit: true,
      userData: null,
      verifyOtpType: 1,
      // 提现阶梯金额，三个通道（PayPal / Card / USDT）共用后端返回的 allow_amount
      allowAmount: 0,
      // 卡通道上限 bankcard_max_amount：比阶梯金额小时压制金额。
      // null 表示后端没下发这个字段（区别于下发了 0），此时视为无卡上限。
      // bankcard_min_amount 不用——下限只按阶梯走。
      cardMaxAmount: null,
      withCheck: {},
      // PayPal / Card 输入的提现金额，最多两位小数
      amountInput: '',
      // /check 或余额加载失败时不展示旧规则、不允许提交，给出重试入口
      checkFailed: false,
      balanceFailed: false,
      minAmount: null,
      maxAmount: null,
      mountedOK: false,
      otpfailed: false,
      // 本次验证是否已发过验证码，用于切换垃圾邮件提示的样式
      otpSent: false,
      emailSentIcon,
      emailUnsentIcon,
      addressList: [],
      addUSDTFlag: false,
      clickWithdrawFlag: false,
      currentAddress: '',
      uploadImageUrl: '',
      uploadFile: null,
      myRank: {
        top: '',
        username: 0,
        earning: 0,
        money: ''
      },
      clickUSDTWithdrawFlag: false,
      deleteAddress: null,
      timer: null,
      // ===== 银行卡提现 =====
      // TODO: Card 的 paymentType 待后端确认，暂用 5；确认后只改这一个常量
      CARD_TYPE: 5,
      cardList: null,
      currentCard: {},
      addCardFlag: false,
      selectCardFlag: false,
      clickCardWithdrawFlag: false,
      addCardFailFlag: false,
      deleteCardId: null,
      cardNumber: '',
      cardExpiry: '',
      // 登录渠道：'phone' | 'email' | ''（未知）；用于提现验证走手机还是邮箱
      loginChannel: '',
      loginEmail: ''
    }
  },
  methods: {
    // 当前账号是从 localStorage 恢复的，可能在别的设备上已经被删掉。不和列表对账的话，
    // 会出现「UI 显示 You haven't added…，提现按钮却是亮的」，点下去必然被后端打回。
    // 对不上就清空而不是自动选第一个——当前账号必须是用户明确选过的，不能替他改收款对象。
    reconcileCurrentAccount (list, current, storageKey) {
      const items = Array.isArray(list) ? list : []
      const no = current && current.bankCardNumber
      if (no && items.some(item => item.bankCardNumber === no)) {
        return current
      }
      window.localStorage.removeItem(storageKey)
      return {}
    },
    // PayPal / Card 提现按钮唯一的前端拦截条件：可提现余额够不够这一笔。
    // 限额、次数这些一律不在前端判，让用户点进去看后端返回的具体原因。
    balanceCovers (amount) {
      return Number(this.realBalance) >= Number(amount)
    },
    // 整数不带小数，否则保留两位，如 $3、$0.50
    usd (value) {
      const n = Math.round(Number(value) * 100) / 100
      return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2))
    },
    // 只保留数字和一个小数点，最多两位小数
    handleAmountInput (e) {
      let v = e.target.value.replace(/[^\d.]/g, '')
      const dot = v.indexOf('.')
      if (dot >= 0) {
        v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, '').slice(0, 2)
      }
      e.target.value = v
      this.amountInput = v
    },
    retryLoad () {
      this.getUserInfo()
      this.withdrawCheck()
    },
    fillMax () {
      if (this.maxEnabled) {
        this.amountInput = String(Math.round(Number(this.channelMax) * 100) / 100)
      }
    },
    // localStorage 里的 JSON 可能缺失或被写坏，裸 JSON.parse 会把整个调用链带崩
    safeParse (raw) {
      if (!raw) return null
      try {
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },
    uuid () {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4'
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = '-'
      return s.join('')
    },

    reportBuriedPoint (key, value) {
      let sdkParams = this.safeParse(window.localStorage.getItem('h5_sdk_params')) || {}
      let aid = sdkParams.aid || ''
      let uid = sdkParams.uid || ''
      let pkg = sdkParams.pkg || ''
      let channel = sdkParams.channel || ''
      let pn = sdkParams.pn || ''
      let now = (new Date().getTime() / 1000).toFixed(0)
      let sendData = JSON.stringify({
        code: this.appInfo ? this.appInfo.code : '',
        cts: now,
        pkg: pkg,
        channel: channel,
        pn: pn,
        aid: aid,
        gaid: this.appInfo ? this.appInfo.gaid : '',
        taurusStatUuid: this.uuid(),
        uid: uid,
        type: 'event',
        listJson: [{ ts: now, eventKey: key, eventValue: value }],
        version: this.appInfo ? this.appInfo.version : ''
      })
      reportBuriedPointRequest('/producerController/send', sendData)
    },

    finish () {
      document.activeElement.blur()
    },
    formatEmail (email) {
      if (!email || !email.includes('@')) {
        return email
      }
      const [name, domain] = email.split('@')
      return `${name.slice(0, 3)}***@${domain}`
    },
    startUSDTWithdraw () {
      let param = JSON.stringify({
        usdtAddress: this.currentAddress,
        network: 'TRC20',
        amount: this.usdtAmount,
        usdtAmount: this.usdtAmount,
        networkFee: this.network_fee
      })

      postRequest(`/region/withdrawUs/payoutUsdt?region=US`, param).then(res => {
        if (res.code === 0 || res.code === 7) {
          // 重新请求数据
          this.getUserInfo()
          this.$router.push({
            path: '/withdraw-submitted',
            query: { paymentType: 4, amount: this.receiveUsdtAmount }
          })
        } else {
          toast(res.msg || 'Something went wrong. Please try again.')
        }
      })
      this.closeVerify()
    },

    clickUsdtWithdraw () {
      this.reportBuriedPoint('us_usdt_click', '')
      this.preWithdrawCheck(2)
    },
    handleInput (e) {
      let value = e.target.value
      if (value === '') {
        this.usdtAmount = ''
        return
      }
      let numValue = parseFloat(value)
      this.usdtAmount = numValue
    },
    formattedAmount (amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount)
    },
    doDelUSDT (item) {
      this.selectUSDTFlag = false
      this.deleteAddress = item.usdtAddress
      this.openOTPVerify(5)
    },

    deleteUSDT () {
      let params = JSON.stringify({
        address: this.deleteAddress,
        network: 'TRC20'
      })
      postRequest(`/landscape/withdrawUsdt/removeAccount`, params).then((res) => {
        if (res.code === 0) {
          if (this.deleteAddress === this.currentAddress) {
            this.currentAddress = null
            window.localStorage.removeItem('with-cur-usdt')
          }
          this.closeVerify()
          toast('Address has been deleted')
        } else {
          this.closeVerify()
          toast('Address delete failed')
        }
      })
    },
    selectUSDT () {
      this.selectUSDTFlag = true
      this.getUSDTList()
      document.body.style.overflow = 'hidden'
    },
    triggerUpload () {
      this.$refs.fileInput.click()
    },
    handleFileChange (e) {
      const file = e.target.files[0]
      if (file) {
        this.uploadFile = file
        this.uploadImageUrl = URL.createObjectURL(file)
      }
    },
    removeImage () {
      this.uploadImageUrl = ''
      this.uploadFile = null
      this.$refs.fileInput.value = ''
    },
    switchTab (type) {
      this.tabType = type
      window.localStorage.setItem('tabType', type)
      if (type === 4) {
        this.reportBuriedPoint('us_usdt_show', '')
      } else if (type === this.CARD_TYPE) {
        this.reportBuriedPoint('us_card_show', '')
      }
      if (type === 3) {
        this.getPaypalList()
        this.withdrawCheck()
      } else if (type === this.CARD_TYPE) {
        this.getCardList()
        this.withdrawCheck()
      }
    },
    toHistory () {
      this.$router.push('/withdraw-history')
    },
    clickWithdraw () {
      this.reportBuriedPoint('us_paypal_click', '')
      this.preWithdrawCheck(1)
    },
    // 从「选择账户」抽屉里点新增：三种账户的选择抽屉都要先收起，
    // 否则它和后面弹出的新增抽屉同为 .drawer 且 DOM 在后面，会盖住新增抽屉
    openOTPVerifyCloseSelect (type) {
      this.selectPaypalFlag = false
      this.selectUSDTFlag = false
      this.selectCardFlag = false
      this.openOTPVerify(type)
    },
    doDelPaypal (item) {
      this.selectPaypalFlag = false
      this.deletePaypalId = item.id
      this.openOTPVerify(2)
    },
    choicePaypalItem (item) {
      this.currentPaypal = item
      localStorage.setItem('with-cur-paypal', JSON.stringify(item))
    },
    choiceUSDTItem (item) {
      this.currentAddress = item.usdtAddress
      window.localStorage.setItem('with-cur-usdt', this.currentAddress)
    },
    selectPaypal () {
      this.selectPaypalFlag = true
      this.getPaypalList()
      document.body.style.overflow = 'hidden'
    },
    toAddPaypal () {
      let params = JSON.stringify({
        code: this.userData.code,
        region: 'US',
        email: this.currentEmail,
        currency: 'USD',
        mobile: this.mobile,
        bankCardNumber: this.currentEmail,
        paymentType: 3
      })

      postRequest(`/region/withdraw/bankAccountController/saveOrUpdate?region=US`, params).then(res => {
        if (res.code === 0) {
          this.currentPaypal = res.data
          localStorage.setItem('with-cur-paypal', JSON.stringify(res.data))
          this.getPaypalList()
          toast('Account added successfully !')
          this.closeVerify()
        } else if (res.code === 2) {
          toast('PayPal account exist.')
        } else {
          toast('Add PayPal account failed.')
        }
      })
    },

    // ===== 银行卡提现 =====
    clickCardWithdraw () {
      this.reportBuriedPoint('us_card_click', '')
      this.preWithdrawCheck(3)
    },
    selectCard () {
      this.selectCardFlag = true
      this.getCardList()
      document.body.style.overflow = 'hidden'
    },
    // TODO: 卡列表接口待后端确认，暂复用 bankAccountController，paymentType 用 CARD_TYPE
    getCardList () {
      postRequest(`/region/withdraw/bankAccountController/query?paymentType=${this.CARD_TYPE}&region=US`, null).then(res => {
        if (res.code === 0) {
          this.cardList = res.data
          this.currentCard = this.reconcileCurrentAccount(res.data, this.currentCard, 'with-cur-card')
        }
      })
    },
    doDelCard (item) {
      this.selectCardFlag = false
      this.deleteCardId = item.id
      this.openOTPVerify(7)
    },
    choiceCardItem (item) {
      this.currentCard = item
      localStorage.setItem('with-cur-card', JSON.stringify(item))
    },
    openAddCard () {
      this.verifyOTPFlag = false
      this.addCardFlag = true
      document.body.style.overflow = 'hidden'
    },
    // 卡号只过滤非数字 + 最多 30 位，不做位数/卡组织校验
    handleCardNumberInput (e) {
      this.cardNumber = this.syncInput(e, (e.target.value || '').replace(/\D/g, '').slice(0, 30))
    },
    // 有效期只做 MM/YY 的格式化，不校验合法性
    handleCardExpiryInput (e) {
      let v = (e.target.value || '').replace(/\D/g, '').slice(0, 4)
      if (v.length >= 3) {
        v = v.slice(0, 2) + '/' + v.slice(2)
      }
      this.cardExpiry = this.syncInput(e, v)
    },
    // :value 绑定在归一化结果和上次相同时不会重渲染（比如已经 30 位还继续按），
    // 这会让输入框里留着被过滤掉的字符，所以这里手动把 DOM 拉回来
    syncInput (e, value) {
      if (e.target.value !== value) {
        e.target.value = value
      }
      return value
    },
    // TODO: 保存卡接口待后端确认，暂复用 bankAccountController/saveOrUpdate
    toAddCard () {
      let params = JSON.stringify({
        code: this.userData.code,
        region: 'US',
        currency: 'USD',
        mobile: this.mobile,
        bankCardNumber: this.cardNumber,
        expireDate: this.cardExpiry,
        cardBrand: this.cardBrand,
        paymentType: this.CARD_TYPE
      })

      postRequest(`/region/withdraw/bankAccountController/saveOrUpdate?region=US`, params).then(res => {
        if (res.code === 0) {
          this.currentCard = res.data
          localStorage.setItem('with-cur-card', JSON.stringify(res.data))
          this.getCardList()
          toast('Card added successfully !')
          this.closeVerify()
        } else {
          // 失败弹窗（设计稿 Add Card failed）
          this.addCardFailFlag = true
        }
      })
    },
    // TODO: 删卡接口待后端确认，暂复用 bankAccountController/delete
    deleteCard () {
      let param = JSON.stringify({ id: this.deleteCardId })
      postRequest(`/region/withdraw/bankAccountController/delete?region=US`, param).then(res => {
        if (res.code === 0) {
          if (this.currentCard && this.currentCard.id === this.deleteCardId) {
            this.currentCard = {}
            window.localStorage.removeItem('with-cur-card')
          }
          toast('Card removed')
          this.getCardList()
          this.closeVerify()
        }
      })
    },
    startCardWithdraw () {
      let param = JSON.stringify({
        amount: this.parsedAmount,
        accountNo: this.currentCard.bankCardNumber
      })
      postRequest(`/region/withdrawUs/payoutCard`, param).then(res => {
        if (res.code === 0) {
          let withdrawId = res.data.withdrawId
          let bankCardNumber = res.data.account
          let amount = res.data.amount
          this.amountInput = ''
          this.getUserInfo()
          this.$router.push({
            path: '/withdraw-submitted',
            query: { paymentType: this.CARD_TYPE, withdrawId, bankCardNumber, amount }
          })
        } else {
          toast(res.msg || 'Something went wrong. Please try again.')
        }
      })
      this.closeVerify()
    },
    // 卡号掩码展示：前4 + 星号 + 后4
    formatCard (num) {
      if (!num) return ''
      const s = String(num)
      if (s.length <= 8) return s
      return `${s.slice(0, 4)}********${s.slice(-4)}`
    },
    // 卡组织识别（前缀），识别不到返回 ''，只影响展示，不拦截提交
    detectCardBrand (num) {
      const s = String(num || '').replace(/\D/g, '')
      if (!s) return ''
      if (/^4/.test(s)) return 'VISA'
      if (/^(5[1-5]|2(2[2-9]|[3-6]\d|7[01]|720))/.test(s)) return 'Mastercard'
      if (/^3[47]/.test(s)) return 'AMEX'
      if (/^(6011|65|64[4-9]|622)/.test(s)) return 'Discover'
      if (/^(60|65|81|82|508)/.test(s)) return 'RuPay'
      return ''
    },

    verifyOtp () {
      let code = this.otp
      let url
      if (this.isEmailVerify) {
        // type=2 服务端才会走邮箱分支，不传会掉进手机号分支
        url = `/region/user/verifyWithdraw?type=2&email=${encodeURIComponent(this.verifyEmail)}&code=${code}&region=US`
      } else {
        url = `/region/user/verifyWithdraw?type=1&mobile=${this.mobile}&code=${code}&region=US`
      }
      getRequest(url).then(res => {
        if (res.code === 0) {
          if (this.verifyOtpType === 1) {
            this.openAddPaypalVerify()
          } else if (this.verifyOtpType === 2) {
            this.delPaypalVerify()
          } else if (this.verifyOtpType === 4) {
            this.openAddUSDT()
          } else if (this.verifyOtpType === 5) {
            this.deleteUSDT()
          } else if (this.verifyOtpType === 6) {
            this.openAddCard()
          } else if (this.verifyOtpType === 7) {
            this.deleteCard()
          }
        } else {
          this.otpfailed = true
        }
      })
    },
    toAddUSDT () {
      const formData = new FormData()
      formData.append('address', this.inputAddress)
      formData.append('network', 'TRC20')
      formData.append('region', 'US')
      formData.append('file', this.uploadFile)

      formPostRequest(`/landscape/withdrawUsdt/createAccount`, formData).then(res => {
        if (res.code === 0) {
          if (!this.currentAddress) {
            const ca = this.inputAddress
            localStorage.setItem('with-cur-usdt', ca)
            this.currentAddress = ca
          }
          toast('Address added successfully !')
          this.closeVerify()
        } else {
          toast(res.msg || 'Something went wrong. Please try again.')
        }
      })
    },
    openAddUSDT () {
      this.verifyOTPFlag = false
      this.addUSDTFlag = true
      document.body.style.overflow = 'hidden'
    },
    delPaypalVerify () {
      let param = JSON.stringify({
        id: this.deletePaypalId
      })
      postRequest(`/region/withdraw/bankAccountController/delete?region=US`, param).then(res => {
        if (res.code === 0) {
          if (this.currentPaypal && this.currentPaypal.id === this.deletePaypalId) {
            // 必须是 {} 不能是 null：模板里 currentPaypal.bankCardNumber 是裸读，
            // 置 null 后在列表刷新回来之前那一帧就会渲染报错（deleteCard 一直是 {}）
            this.currentPaypal = {}
            window.localStorage.removeItem('with-cur-paypal')
          }
          toast('PayPal account removed')
          // 原静态页此处 location.reload() 刷新；SPA 里改为重新拉取列表并收起抽屉
          this.getPaypalList()
          this.closeVerify()
        }
      })
    },
    exit () {
      // 只有壳另开的 WebView（地址带 entry=withdraw-us）才关页；页内跳转进来的走路由返回
      const ownPage = new URLSearchParams(window.location.search).get('entry') === 'withdraw-us'
      if (ownPage && window.jskit && typeof window.jskit.closePage === 'function') {
        window.jskit.closePage()
        return
      }
      this.$router.push('/main')
    },

    // verifyOtpType: 1/2 paypal, 4/5 usdt, 6/7 card; odd adds an account, even deletes one
    otpChannel (type) {
      if (type === 1 || type === 2) {
        return 'paypal'
      }
      if (type === 4 || type === 5) {
        return 'usdt'
      }
      if (type === 6 || type === 7) {
        return 'card'
      }
      return ''
    },
    openOTPVerify (type) {
      if (type) {
        this.verifyOtpType = type
      }
      this.verifyOTPFlag = true
      document.body.style.overflow = 'hidden'
      const channel = this.otpChannel(this.verifyOtpType)
      if (this.verifyOtpType === 1 || this.verifyOtpType === 4 || this.verifyOtpType === 6) {
        this.reportBuriedPoint('us_add_account_click', '')
        if (channel) {
          this.reportBuriedPoint('us_add_account_click_' + channel, '')
        }
      }
      this.reportBuriedPoint('us_otp_show', '')
      this.reportBuriedPoint(this.isEmailVerify ? 'us_otp_show_email' : 'us_otp_show_mobile', '')
      if (channel) {
        this.reportBuriedPoint('us_otp_show_' + channel, '')
      }
    },
    openAddPaypalVerify () {
      this.verifyOTPFlag = false
      this.addPaypalFlag = true
      document.body.style.overflow = 'hidden'
    },
    closeVerify () {
      this.selectUSDTFlag = false
      this.otpfailed = false
      this.otpSent = false
      this.verifyOTPFlag = false
      this.otp = null
      this.addPaypalFlag = false
      this.selectPaypalFlag = false
      this.clickWithdrawFlag = false
      this.addUSDTFlag = false
      this.inputAddress = null
      this.deleteAddress = null
      this.uploadImageUrl = null
      this.uploadFile = null
      this.clickUSDTWithdrawFlag = false
      // 银行卡相关抽屉/输入一并清掉
      this.addCardFlag = false
      this.selectCardFlag = false
      this.clickCardWithdrawFlag = false
      this.deleteCardId = null
      this.cardNumber = ''
      this.cardExpiry = ''
      document.body.style.overflow = ''
    },

    startWithdraw () {
      let param = JSON.stringify({
        amount: this.parsedAmount,
        accountNo: this.currentPaypal.bankCardNumber
      })
      postRequest(`/region/withdrawUs/payoutPaypal`, param).then(res => {
        if (res.code === 0) {
          let withdrawId = res.data.withdrawId
          let bankCardNumber = res.data.account
          let amount = res.data.amount
          this.amountInput = ''
          this.getUserInfo()
          this.$router.push({
            path: '/withdraw-submitted',
            query: { withdrawId, bankCardNumber, amount }
          })
        } else {
          toast(res.msg || 'Something went wrong. Please try again.')
        }
      })
      this.closeVerify()
    },

    getOtp () {
      if (this.countdown > 0) return
      let url
      if (this.isEmailVerify) {
        url = `/region/user/get_verify_code?type=2&email=${encodeURIComponent(this.verifyEmail)}&region=US&pn=${this.appInfo.pn || ''}`
      } else {
        url = `/region/user/get_verify_code?type=1&mobile=${this.mobile}&region=US`
      }
      getRequest(url).then(res => {})
      this.otpSent = true
      this.startCountdown()
    },

    startCountdown () {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },

    getUserInfo () {
      let uid
      if (this.appInfo.cg_uid) {
        uid = this.appInfo.cg_uid
      } else {
        const params = new URLSearchParams(window.location.search)
        if (params.get('uid')) {
          uid = params.get('uid')
        } else {
          uid = ''
        }
      }

      let aid = this.appInfo.aid || ''
      let channelid = this.appInfo.gc || ''
      let pkg = (this.safeParse(window.localStorage.getItem('h5_sdk_params')) || {}).pkg || ''
      let pn = this.appInfo.pn || ''

      let source = ''
      let extra = ''
      getRequest(`/region/vgi/index?pn=${pn}&id=&uid=${uid}&aid=${aid}&channelid=${channelid}&pkg=${pkg}&source=${source}&extra=${extra}&region=US`, {}).then(res => {
        // 余额拿不到时提现按钮会一直置灰（balanceCovers 判不过），
        // 必须给出提示，否则用户只看到一个点不动的按钮
        if (isRequestFailed(res) || !res.data) {
          this.balanceFailed = true
          toast('Failed to load your balance. Please try again.')
          return
        }
        this.balanceFailed = false
        this.userData = res.data
        this.mobile = res.data.mobile
        if (this.mobile) {
          this.singleMobile = this.mobile.substring(1)
        }
        this.realBalance = res.data.realBalance
        this.showBalance = res.data.showBalance
      })
    },
    appConfig () {
      // vuex 这个 key 缺失/损坏时兜成 {}，否则后面 this.appInfo.xxx 全线抛错
      const saved = this.safeParse(localStorage.getItem('vuex')) || {}
      // 持久化的那份缺字段时（iOS 冷启动不保留 localStorage、新开的 WebView 读不到），
      // 依次回退到内存里的 vuex 和地址栏带进来的 h5_sdk_params
      const state = this.$store.state
      const sdk = this.safeParse(localStorage.getItem('h5_sdk_params')) || {}
      this.appInfo = Object.assign({}, saved, {
        code: saved.code || state.code || '',
        aid: saved.aid || state.aid || sdk.aid || '',
        cg_uid: saved.cg_uid || state.uid || sdk.uid || '',
        gc: saved.gc || state.channel || sdk.channel || '',
        pn: saved.pn || state.pn || sdk.pn || '',
        version: saved.version || state.pkg || sdk.pkg || ''
      })
    },
    getPaypalList () {
      postRequest(`/region/withdraw/bankAccountController/query?paymentType=3&region=US`, null).then(res => {
        if (res.code === 0) {
          this.paypalAccountList = res.data
          this.currentPaypal = this.reconcileCurrentAccount(res.data, this.currentPaypal, 'with-cur-paypal')
        }
      })
    },
    // /check 的结果落到组件状态。进页面和每次点提现都会调，保证阶梯金额是最新的。
    applyWithdrawCheck (res) {
      this.withCheck = res
      this.checkFailed = false
      this.allowAmount = res.allow_amount
      // 用 || 0 会把「字段缺失」和「上限就是 0」混为一谈，前者应当不压制金额
      this.cardMaxAmount = typeof res.bankcard_max_amount === 'number' ? res.bankcard_max_amount : null
      this.showUsdtTab = res.usdt_withdraw_show
      this.maxAmount = res.max_amount
      this.minAmount = res.min_amount
      this.network_fee = res.network_fee
    },

    preWithdrawCheck (type) {
      let param = JSON.stringify({})
      postRequest(`/region/withdrawUs/check`, param).then(res => {
        // 校验请求本身失败时必须挡住：以前会因为 res.status !== 3 判成通过，
        // PayPal 照样弹确认抽屉，Card 则误报「今日额度已用完」
        if (isRequestFailed(res)) {
          toast(res.msg || 'Something went wrong. Please try again.')
          return
        }
        // 三个通道共用同一份 /check，点提现时统一刷新一次，
        // 否则确认抽屉里显示、以及最终提交的可能是进页面时的旧阶梯值
        this.applyWithdrawCheck(res)

        // 三条通道的拦截口径一致：只认后端的 status===3（今日额度用完）。
        // 限额之类的不在前端判，走到后端由它返回具体原因。
        if (res.status === 3) {
          toast('You’ve reached today’s withdrawal limit. Please try again tomorrow.')
          return
        }
        // 刷新后 PayPal / Card 不满足条件就不弹确认，原因由页面上的红字和黄条说明
        if ((type === 1 && !this.paypalCanWithdraw) || (type === 3 && !this.cardCanWithdraw)) {
          return
        }
        if (type === 1) {
          this.clickWithdrawFlag = true
        } else if (type === 2) {
          this.clickUSDTWithdrawFlag = true
        } else if (type === 3) {
          this.clickCardWithdrawFlag = true
        }
      })
    },

    withdrawCheck () {
      let param = JSON.stringify({})
      postRequest(`/region/withdrawUs/check`, param).then(res => {
        // 失败时保持上一次的状态，不要把 withCheck 覆盖成失败对象——
        // 那会让金额变空、Card/USDT tab 直接消失，而且页面上毫无提示
        if (isRequestFailed(res)) {
          this.checkFailed = true
          toast(res.msg || 'Something went wrong. Please try again.')
          return
        }
        this.applyWithdrawCheck(res)
        // tab 恢复只在进页面这一次做，放进 applyWithdrawCheck 会在点提现时把用户当前 tab 顶掉
        let tab = window.localStorage.getItem('tabType')
        if (tab) {
          const t = Number(tab)
          // 记住上次选中的 tab：USDT 需开关开启，Card 只要未被显式关闭
          if ((t === 4 && this.withCheck.usdt_withdraw_show) ||
              (t === this.CARD_TYPE && this.showCardTab) ||
              t === 3) {
            this.tabType = t
          }
        } else if (this.showCardTab) {
          // 没有记录过 tab 时 Card 优先
          this.tabType = this.CARD_TYPE
        }
      })
    },

    getUSDTList () {
      getRequest(`/landscape/withdrawUsdt/listAccount?region=US`, null).then(res => {
        // 这个接口直接返回数组，没有 code 包装。以前只判 `if (res)`，
        // 失败时会把非数组赋进去，v-for 就按字符/键渲染出垃圾行
        if (Array.isArray(res)) {
          this.addressList = res
          // 同 reconcileCurrentAccount：缓存的地址可能已被删，字段是 usdtAddress、存的是字符串
          if (this.currentAddress && !res.some(item => item.usdtAddress === this.currentAddress)) {
            this.currentAddress = ''
            window.localStorage.removeItem('with-cur-usdt')
          }
        }
      })
    },

    formatedDisplayAddress (address) {
      if (!address) return ''
      const value = address
      if (value.length <= 12) {
        return value
      }
      return `${value.slice(0, 4)}******${value.slice(-4)}`
    },

    onTokenExpired () {
      this.closeVerify()
      toast('Your session has expired. Please log in again.')
      this.exit()
     },

    restorePassedToken () {
      const token = new URLSearchParams(window.location.search).get('token')
      if (!token || token === this.$store.state.token) {
        return
      }
      try {
        this.$store.commit('token', token)
      } catch (e) {
        console.log(e)
      }
    }
  },
  created () {
    // 这几个缓存被写坏时不能让 created 抛错，否则整页起不来；解析失败就当没缓存
    this.currentPaypal = this.safeParse(localStorage.getItem('with-cur-paypal')) || {}

    let withdrawUsdtAddress = localStorage.getItem('with-cur-usdt')
    if (withdrawUsdtAddress) {
      this.currentAddress = withdrawUsdtAddress
    }

    this.currentCard = this.safeParse(localStorage.getItem('with-cur-card')) || {}

    // 登录渠道（LoginDialog 登录成功时写入）
    this.loginChannel = localStorage.getItem('us_login_type') || ''
    this.loginEmail = localStorage.getItem('us_login_email') || ''
  },
  mounted () {
    this.restorePassedToken()
    this.appConfig()
    // 提现页不挂载 AppMain（登录弹窗的宿主），token 过期得自己收场：
    // 抽屉全收起、恢复滚动，再退回主页由那边走登录流程
    bus.on('tokenExpired', this.onTokenExpired)
    this.reportBuriedPoint('us_withdraw_show', '')
    this.getUserInfo()
    this.withdrawCheck()
    this.getPaypalList()
    this.getUSDTList()
    this.getCardList()
  },

  computed: {
    balanceCardStyle () {
      return {
        backgroundImage: `url(${process.env.BASE_URL}assets/withdraw-us/balance-bg.png)`
      }
    },
    insufficientAmount () {
      return this.realBalance < this.usdtAmount
    },
    leastMinAmount () {
      return this.usdtAmount < this.minAmount
    },
    receiveUsdtAmount () {
      const result = Number(this.usdtAmount) - Number(this.network_fee)
      return result > 0 ? parseFloat(result.toFixed(6)) : 0
    },
    usdtMaxAmountWarningTips () {
      return this.usdtAmount > this.effectiveMax
    },
    usdtCanWithdraw () {
      const amount = parseFloat(this.usdtAmount)
      if (isNaN(amount)) return false
      if (!this.currentAddress) {
        return false
      }
      return (
        amount >= this.minAmount &&
        amount <= this.maxAmount &&
        amount <= this.realBalance
      )
    },
    effectiveMax () {
      return Math.min(this.maxAmount, this.realBalance)
    },
    displayAddress () {
      if (!this.currentAddress) return ''
      const value = this.currentAddress
      if (value.length <= 12) {
        return value
      }
      return `${value.slice(0, 4)}******${value.slice(-4)}`
    },
    canAddUSDT () {
      return this.validUsdtAddress && this.uploadFile
    },
    validUsdtAddress () {
      const value = this.inputAddress || ''
      const tron = /^T[a-zA-Z0-9]{33}$/
      const evm = /^0x[a-fA-F0-9]{40}$/
      return tron.test(value) || evm.test(value)
    },
    canAddPaypal () {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.currentEmail)
    },
    formatMobile () {
      if (!this.mobile) {
        return ''
      }
      return this.mobile.substring(1)
    },
    canVerify () {
      if (!this.otp || this.otp.length !== 4) return false
      if (this.isEmailVerify) return !!this.verifyEmail
      return this.mobile && this.mobile.length === 11
    },
    // 是否走邮箱验证：优先登录时记录的渠道；未知时（iOS 冷启动不保留 localStorage）以 /check 返回的 email 为准
    isEmailVerify () {
      if (this.loginChannel === 'email') return true
      if (this.loginChannel === 'phone') return false
      return !!this.withCheck.email
    },
    verifyEmail () {
      return this.loginEmail || this.withCheck.email || ''
    },
    rangeMaxWithdraw () {
      return Math.min(this.maxAmount, this.realBalance)
    },
    paypalCanWithdraw () {
      return !!(this.amountReady && this.currentPaypal && this.currentPaypal.bankCardNumber)
    },
    // ===== PayPal / Card 共用阶梯：取值见 /check 的 paypal_*、bankcard_*、period_* =====
    // /check 和余额都返回后才展示规则和校验，避免加载中出现 $NaN
    rulesReady () {
      return this.withCheck.paypal_min_amount !== undefined && this.withCheck.paypal_min_amount !== null &&
        this.realBalance !== null && this.realBalance !== undefined
    },
    channelMin () {
      return Number(this.tabType === this.CARD_TYPE ? this.withCheck.bankcard_min_amount : this.withCheck.paypal_min_amount)
    },
    channelMax () {
      return Number(this.tabType === this.CARD_TYPE ? this.withCheck.bankcard_max_amount : this.withCheck.paypal_max_amount)
    },
    channelSingleMax () {
      return Number(this.tabType === this.CARD_TYPE ? this.withCheck.bankcard_single_max : this.withCheck.paypal_single_max)
    },
    // 输入不合法时为 NaN
    parsedAmount () {
      return /^\d+(\.\d{1,2})?$/.test(this.amountInput) ? Number(this.amountInput) : NaN
    },
    periodWord () {
      const t = this.withCheck.period_type
      return t === 'week' ? 'weekly' : t === 'month' ? 'monthly' : 'daily'
    },
    hasPeriodCount () {
      return this.withCheck.period_count_remaining !== null && this.withCheck.period_count_remaining !== undefined
    },
    hasPeriodAmount () {
      return this.withCheck.period_amount_remaining !== null && this.withCheck.period_amount_remaining !== undefined
    },
    // 红字：输入金额的校验
    amountError () {
      if (this.checkFailed || !this.rulesReady || this.amountInput === '') {
        return ''
      }
      const amount = this.parsedAmount
      if (isNaN(amount) || amount <= 0 || amount < this.channelMin) {
        return `Enter a valid withdrawal amount. Your current minimum withdrawal is ${this.usd(this.channelMin)}.`
      }
      if (!this.balanceCovers(amount)) {
        return `Amount exceeds your withdrawable balance of ${this.usd(this.realBalance)}.`
      }
      if (amount > this.channelSingleMax) {
        return `Maximum per withdrawal: ${this.usd(this.channelSingleMax)}.`
      }
      if (this.hasPeriodAmount && amount > Number(this.withCheck.period_amount_remaining)) {
        return `Remaining ${this.periodWord} withdrawal allowance: ${this.usd(this.withCheck.period_amount_remaining)}.`
      }
      // 卡当日额度、$100 以上的单笔上限等其余限制已折进 Max
      if (this.channelMax > 0 && amount > this.channelMax) {
        return `Maximum per withdrawal: ${this.usd(this.channelMax)}.`
      }
      return ''
    },
    // 灰字：当前最低门槛、单笔上限；配了周期限额时加剩余次数和额度
    ruleLines () {
      if (this.checkFailed || this.balanceFailed || !this.rulesReady || (this.tabType !== 3 && this.tabType !== this.CARD_TYPE)) {
        return []
      }
      const lines = [`Minimum: ${this.usd(this.channelMin)} · Maximum: ${this.usd(this.channelSingleMax)}`]
      const parts = []
      if (this.hasPeriodCount) {
        const n = this.withCheck.period_count_remaining
        parts.push(`${n} withdrawal${n === 1 ? '' : 's'}`)
      }
      if (this.hasPeriodAmount) {
        parts.push(this.usd(this.withCheck.period_amount_remaining))
      }
      if (parts.length) {
        const label = { week: 'this week', month: 'this month' }[this.withCheck.period_type] || 'today'
        lines.push(`Remaining ${label}: ${parts.join(' · ')}`)
      }
      if (this.withCheck.ladder_completed && this.channelMax >= this.channelMin && this.channelMax > 0) {
        lines.push(`You can withdraw any amount from ${this.usd(this.channelMin)} to ${this.usd(this.channelMax)}.`)
      }
      return lines
    },
    // 黄条：只展示一个最高优先级的限制
    limitAlert () {
      if (this.tabType !== 3 && this.tabType !== this.CARD_TYPE) {
        return ''
      }
      if (this.checkFailed || this.balanceFailed) {
        return 'Unable to load withdrawal rules. Please try again.'
      }
      if (!this.rulesReady) {
        return ''
      }
      const channel = this.tabType === this.CARD_TYPE ? 'Card' : 'PayPal'
      const time = this.withCheck.period_reset_text
      // 阶梯阶段上一笔还在处理中：沿用原逻辑，status=2 且 allow_amount=0 时不可提
      if (this.withCheck.status === 2 && Number(this.withCheck.allow_amount) === 0) {
        return 'Your previous withdrawal is still being processed. Please try again later.'
      }
      if (this.hasPeriodCount && Number(this.withCheck.period_count_remaining) === 0) {
        return `You've reached your ${this.periodWord} withdrawal count limit. Try again at ${time}.`
      }
      if (this.withCheck.status === 3) {
        return 'You’ve reached today’s withdrawal limit. Please try again tomorrow.'
      }
      if (this.hasPeriodAmount && Number(this.withCheck.period_amount_remaining) < this.channelMin) {
        return Number(this.withCheck.period_amount_remaining) === 0
          ? `You've reached your ${this.periodWord} withdrawal amount limit. Try again at ${time}.`
          : `Your remaining ${this.periodWord} allowance is below the minimum available withdrawal amount. Try again at ${time}.`
      }
      if (!this.balanceCovers(this.channelMin)) {
        return `Your current minimum withdrawal is ${this.usd(this.channelMin)}. You need ${this.usd(this.channelMin - Number(this.realBalance))} more in withdrawable balance.`
      }
      if (!(this.channelMax > 0)) {
        return `${channel} withdrawals are temporarily unavailable. Try again later.`
      }
      return ''
    },
    // 未选账户时 Max 仍可用
    maxEnabled () {
      return this.rulesReady && !this.limitAlert && this.channelMax > 0
    },
    receiveText () {
      return this.amountInput !== '' && !this.amountError && !isNaN(this.parsedAmount) ? this.usd(this.parsedAmount) : '—'
    },
    amountReady () {
      return this.rulesReady && !this.limitAlert && this.amountInput !== '' && !isNaN(this.parsedAmount) && !this.amountError
    },
    // ===== 银行卡提现 =====
    showCardTab () {
      return this.withCheck.bankcard_withdraw_enable === true
    },
    // 卡的提现金额同样走 allow_amount 阶梯，但受卡通道上限压制：
    // bankcard_max_amount 比阶梯金额小时按它来（取两者较小值）。
    // 下限只按阶梯走，bankcard_min_amount 不参与。
    cardAllowAmount () {
      if (this.cardMaxAmount === null) {
        return this.allowAmount
      }
      return Math.min(this.allowAmount, this.cardMaxAmount)
    },
    cardCanWithdraw () {
      return !!(this.amountReady && this.currentCard && this.currentCard.bankCardNumber)
    },
    // 卡组织只用于在输入框右侧展示，识别不到为 ''，不影响能否提交
    cardBrand () {
      return this.detectCardBrand(this.cardNumber)
    },
    canAddCard () {
      // 前端不校验位数/有效期/卡组织，两个字段都填了就能提交，剩下交给后端
      return !!this.cardNumber && !!this.cardExpiry
    }
  },

  beforeUnmount () {
    bus.off('tokenExpired', this.onTokenExpired)
    if (this.timer) {
      clearInterval(this.timer)
    }
    // 离开页面时恢复背景滚动，避免抽屉打开状态下路由跳转残留 overflow:hidden
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.usdt_a_tips {
  font-size: .26rem;
}
.mobiletext {
  font-size: .32rem;
  color: #000000;
}
.allow_amount_s {
  font-weight: bold;
  background-color: #F6F3F3;
  font-size: .5rem;
}

/* ===== 银行卡提现 ===== */
/* 蓝色银行卡图标（源图 59x40，比例 1.475）*/
.card-brand-icon {
  display: inline-block;
  flex: none;
  width: .58rem;
  height: .39rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url("@/assets/ic_bank_card.png");
}
.big-card-icon {
  width: 1rem;
  height: .68rem;
}
.withdraw-form-card-icon {
  width: 1.03rem;
  height: .7rem;
}
.card-brand-text {
  flex: none;
  font-size: .3rem;
  font-weight: bold;
  font-style: italic;
  color: #1A1F71;
}
/* 加卡失败弹窗 */
.fail-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fail-dialog {
  width: 5.8rem;
  background: #fff;
  border-radius: .24rem;
  padding: .5rem .4rem .4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* 源图自带浅橙色外圈，直接用图片，方形等比 */
.fail-icon {
  width: 1.44rem;
  height: 1.44rem;
  margin-bottom: .4rem;
}
.fail-title {
  font-size: .36rem;
  font-weight: bold;
  color: #1B1B1D;
  margin-bottom: .2rem;
}
.fail-desc {
  font-size: .28rem;
  color: #7A7A7A;
  text-align: center;
  margin-bottom: .5rem;
}
.fail-btn {
  width: 100%;
  height: 1rem;
  border: none;
  border-radius: .2rem;
  background: #4625BB;
  color: #fff;
  font-size: .32rem;
}
.tron-line {
  display: flex;
  gap: .1rem;
  margin-top: .1rem;
}
.trc20 {
  background-color: #509f7d;
  padding: .06rem .12rem;
  color: white;
  border-radius: 0.08rem;
}
.usdt_amount_warning_tips {
  padding: .1rem .2rem;
  margin-top: .1rem;
  background-color: #f8ecef;
  border-radius: 0.14rem;
  display: flex;
  gap: .1rem;
  color: #FF0000;
  font-size: .26rem;
  margin: .2rem 0;
}
/* 蒙层 */
.drawer-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
}

/* 抽屉 */
.drawer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60vh;
  background: #fff;
  border-radius: 0.3rem 0.3rem 0 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.drawer-high {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60vh;
  background: #fff;
  border-radius: 0.3rem 0.3rem 0 0;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}

/* 动画 */
.drawer-up-enter-active,
.drawer-up-leave-active {
  transition: all 0.3s ease;
}

.drawer-up-enter {
  transform: translateY(100%);
}

.otp-wrong {
  background-color: #fcf3f3;
  padding: .1rem .2rem;
  gap: .1rem;
  display: flex;
  align-items: center;
  border-radius: .2rem;
  margin-top: .2rem;
}
.otp-wrong span {
  color: #CB2421;
  font-size: .26rem;
}

.warning-tips {
  height: .3rem;
  width: auto;
}

/* 垃圾邮件提示：未发送为浅黄底，发送后为紫底高亮 */
.email-tips {
  margin-top: .24rem;
  padding: .2rem .24rem;
  display: flex;
  align-items: center;
  border-radius: .1rem;
  background-color: #FCE0A4;
}

.email-tips.sent {
  background-color: #4625BB;
}

.email-tips-icon {
  width: .48rem;
  height: .48rem;
  flex-shrink: 0;
  margin-right: .2rem;
}

.email-tips-title {
  font-size: .3rem;
  font-weight: bold;
  line-height: .4rem;
  color: #111111;
}

.email-tips-desc {
  font-size: .28rem;
  line-height: .38rem;
  color: #111111;
}

.email-tips-desc span {
  color: #FF2A2A;
}

.email-tips.sent .email-tips-title,
.email-tips.sent .email-tips-desc {
  color: #FFFFFF;
}

.email-tips.sent .email-tips-desc span {
  color: #FFC01F;
}

.drawer-up-enter-to {
  transform: translateY(0);
}

.drawer-up-leave {
  transform: translateY(0);
}

.drawer-up-leave-to {
  transform: translateY(100%);
}

/* 头部 */
.drawer-header {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: bold;
}

.select-account-right {
  height: .4rem;
  width: .4rem;
}

.drawer-header .back {
  position: absolute;
  left: 0.2rem;
  height: 0.3rem;
}

/* 内容 */
.drawer-body {
  padding: 0.3rem;
}

.form-item {
  margin-bottom: 0.3rem;
  margin-top: 0.4rem;
}

.label {
  font-size: .26rem;
  margin-bottom: 0.1rem;
  color: #333;
}
.label-1 {
  font-size: .28rem;
  margin-bottom: 0.16rem;
  color: #000000;
}

.input-box {
  display: flex;
  align-items: center;
  gap: .1rem;
  border: 1px solid #eee;
  border-radius: 0.1rem;
  padding: 0.1rem;
}

.noinput-box {
  display: flex;
  align-items: center;
  gap: .1rem;
  border-radius: 0.1rem;
  padding: 0.1rem;
  padding-left: .3rem;
  background-color: #F6F3F3;
  height: 1rem;
  border: 1px solid #C9C4D7;
}

.input-icon {
  height: .53rem;
  width: auto;
}

input::placeholder {
  color: #A2A2A2;
}

.input-span {
  font-size: .32rem;
}

.input-box input {
  flex: 1;
  font-size: .32rem;
  border: none;
  outline: none;
  min-width: 0;
}

.otp-btn {
  margin-left: 0.2rem;
  flex-shrink: 0;
  background: #4625BB;
  color: #fff;
  border: none;
  font-size: .26rem;
  height: .8rem;
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
}

.otp-btn:disabled {
  background: #8e7df2;
}

/* 按钮 */
.verify-btn {
  font-size: .32rem;
  width: 100%;
  height: 1rem;
  background: #8e7df2;
  color: #fff;
  border: none;
  border-radius: 0.2rem;
  margin-top: 0.5rem;
  opacity: 0.7;
  cursor: not-allowed;
  transition: all 0.2s;
}

.verify-btn.active {
  background: #4625BB;
  opacity: 1;
  cursor: pointer;
}
.confirm-btn-3 {
  font-size: .32rem;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  height: 1rem;
  background: #8e7df2;
  color: #fff;
  border: none;
  border-radius: 0.2rem;
  margin-top: 0.5rem;
  opacity: 0.7;
  cursor: not-allowed;
  transition: all 0.2s;
  position: absolute;
  bottom: .4rem;
}

.confirm-btn-3.active {
  background: #4625BB;
  opacity: 1;
  cursor: pointer;
}

.confirm-btn {
  font-size: .32rem;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  height: 1rem;
  background: #8e7df2;
  color: #fff;
  border: none;
  border-radius: 0.2rem;
  margin-top: 0.5rem;
  opacity: 0.7;
  cursor: not-allowed;
  transition: all 0.2s;
  position: absolute;
  bottom: 1rem;
}
.confirm-btn.active {
  background: #4625BB;
  opacity: 1;
  cursor: pointer;
}

.confirm-btn-2-group {
  bottom: .2rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: .2rem;
}

.confirm-btn-2 {
  font-size: .32rem;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  height: 1rem;
  background: #8e7df2;
  color: #fff;
  border: none;
  border-radius: 0.2rem;
  opacity: 0.7;
  cursor: not-allowed;
  transition: all 0.2s;
}

.confirm-btn-2.active {
  background: #4625BB;
  opacity: 1;
  cursor: pointer;
}

* {
  padding: 0;
  margin: 0;
  color: #1B1B1D;
  font-size: 0.2rem;
}

.withdraw-root {
  height: 100vh;
  height: 100dvh; /* 移动端用动态视口高度，避免被状态栏/浏览器栏挤掉底部 */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 7.2rem;
  max-width: 7.2rem;
  margin: 0 auto;
  background-color: #FCF8FB;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
}

@media screen and (min-width: 768px) {
  .withdraw-root {
    max-width: none;
    width: 100%;
    margin: 0;
  }
}

.withdraw-content {
  flex: 1;
  position: relative;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
}

/* 纵向撑满剩余高度，底部按钮区靠 margin-top: auto 贴底 */
.content-right,
#paypal-root,
#usdt-root,
#card-root {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Header */
.header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #fff;
  height: 0.88rem;
  /* 内容超过一屏时不被 flex 压缩 */
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.3rem;
}

.left-icon {
  height: 0.3rem;
}

.title {
  font-size: 0.36rem;
  color: #333;
  font-weight: bold;
}

.placeholder {
  width: 0.44rem;
}

.balance-card {
  overflow: hidden;
  margin: 0.2rem;
  height: 2.87rem;
  border-radius: .12rem;
  width: auto;
  background-size: cover;
  background-position: center;
}
.balance-card .total-balance {
  margin-top: .5rem;
  margin-bottom: .5rem;
  padding: 0 .4rem;
}
.balance-card .total-balance .balance-font {
  color: #ffffff;
  font-size: .26rem;
}
.balance-card .total-balance .balance-am {
  color: #ffffff;
  font-size: .5rem;
  font-weight: bold;
}

.card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-size: 0.28rem;
  color: rgba(255,255,255,0.8);
}

.history-btn {
  display: flex;
  align-items: center;
  height: 0.5rem;
  padding: 0 0.2rem;
  border-radius: 0.25rem;
  background-color: rgba(255,255,255,0.2);
}

.history-text {
  font-size: 0.24rem;
}

.middle-row {
  margin-top: 0.2rem;
  justify-content: flex-start;
}

.amount {
  font-size: 0.64rem;
  font-weight: bold;
}

.ba-line {
  margin: .08rem .4rem;
  height: .02rem;
  background-color: #ffffff;
  opacity: 20%;
}

.ba-withdrawable-amount {
  display: flex;
  align-items: center;
  margin: .2rem .4rem;
  justify-content: space-between;
  height: auto;
  flex: 1;
}
.ba-withdrawable-amount .ba-withdrawable-amount-font {
  font-size: 0.28rem;
  color: #ffffff;
  opacity: 90%;
}
.ba-withdrawable-amount .ba-withdrawable-amount-am {
  font-size: .32rem;
  font-weight: bold;
  color: #ffffff;
}

.paypal-icon {
  height: .4rem;
  width: auto;
}

.usdt-icon2 {
  height: .3rem;
  width: auto;
}

.usdt-icon {
  height: .68rem;
  width: auto;
}

.total-balance-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.history-button {
  height: .42rem;
  width: auto;
}
/* Tabs */
.tabs-container {
  display: flex;
  margin-top: 0.2rem;
  padding: 0 0.2rem;
  width: 100%;
  box-sizing: border-box;
}
.tab-item {
  height: 1rem;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  font-weight: bold;
  color: #999;
}

.tab-item.active {
  color: #5E44D3;
  font-weight: bold;
  position: relative;
}

.tab-item.active:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 0.06rem;
  background: #6c5ce7;
  border-radius: 0.03rem;
}

/* Section */
.section-title {
  margin-top: 0.4rem;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  color: #1B1B1D;
  font-weight: 700;
}

/* Account */
.account-section {
  padding: 0 0.2rem;
}

.account-card {
  padding: .2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background: #F0EDEF;
  border-radius: 0.16rem;
  border: 0.02rem solid #C9C4D7;
}

.sm-paypal {
  height: .39rem;
  width: auto;
}

.account-card .icon {
  width: 0.8rem;
  height: 0.8rem;
}

.arrow-right {
  width: .2rem;
  height: auto;
  margin-right: 0.2rem;
}

.current-paypal-container {
  padding: 0 0.2rem;
  height: 1.1rem;
  display: flex;
  align-items: center;
  background: #ffffff;
  justify-content: space-between;
  border-radius: 0.16rem;
  border: 0.02rem solid #C9C4D7;
}

.current-paypal-container-left {
  display: flex;
  align-items: center;
  gap: .2rem;
}
.current-paypal-container-left span {
  font-size: .32rem;
}

.list-paypal-container {
  padding: 0 0.2rem;
  height: 1.1rem;
  display: flex;
  align-items: center;
  background: #ffffff;
  justify-content: space-between;
  border-bottom: 0.02rem solid #C9C4D7;
}

.right-action {
  display: flex;
  align-items: center;
  gap: 1.8rem;
}

.no-address-text {
  margin-top: 0.2rem;
  font-size: 0.26rem;
  color: #000000;
}

.add-btn {
  margin-top: 0.3rem;
  padding: 0.1rem 0.2rem;
  font-size: 0.26rem;
  color: #4625BB;
  background: #D2D3FF;
  border: none;
  border-radius: 0.1rem;
}

/* Input */
.input-section {
  padding: 0 0.2rem;
}

.input-box {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.2rem;
  border: 0.02rem solid #eee;
  border-radius: 0.1rem;
  background: #fff;
}

.prefix {
  width: 0.5rem;
  font-size: 0.4rem;
}

.amount-input {
  flex: 1;
  height: 0.34rem;
  font-size: 0.26rem;
  border: none;
  outline: none;
}

.suffix-btn {
  width: 0.8rem;
  font-size: 0.3rem;
  text-align: right;
}

.limit-row {
  display: flex;
  justify-content: space-between;
  margin: 0.2rem 0.1rem;
  font-size: 0.26rem;
}
.limit-label {
  color: #A2A2A2;
  font-size: .26rem;
}
.limit-value {
  font-size: .26rem;
  color: #000000;
}

/* Receive */
/* 与按钮一起贴底（margin-top: auto）；上内边距含原按钮区的 0.2rem 与原外边距 0.4rem，左右与按钮区内容对齐 */
.receive-section {
  margin: auto calc(4% + 0.2rem) 0;
  padding: 0.8rem 0.2rem 0;
}

.receive-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.28rem;
}

/* Bottom */
/* 内容不足一屏时随 Receive amount 贴底；超过一屏时按钮悬浮在屏幕底部，滚到底后排在内容之后 */
.bottom-action {
  position: sticky;
  bottom: 0;
  /* 底色铺满整行，遮住从下方滚过的内容；左右内边距 4% + 0.2rem，按钮区宽度仍为 92% */
  width: 100%;
  background-color: #FCF8FB;
  /* 避开底部安全区（刘海屏 home 指示条），保证按钮完整可点 */
  padding: 0.2rem calc(4% + 0.2rem) calc(0.4rem + env(safe-area-inset-bottom, 0px));
}

.withdraw-btn {
  width: 100%;
  height: 1rem;
  font-size: 0.36rem;
  color: #fff;
  background: #4127b4;
  border: none;
  border-radius: 0.16rem;
}

.withdraw-btn:disabled {
  background: #aea5f2;
}

/* PayPal / Card 金额区：颜色、字号沿用本页已有样式，待设计稿标注后校准 */
.account-tips {
  margin: .1rem .1rem 0;
  color: #FF0000;
  font-size: .26rem;
}
.amount-box.invalid {
  border-color: #FF0000;
  background: #fcf3f3;
}
.amount-box.invalid .amount-input {
  background: transparent;
}
.max-btn {
  flex-shrink: 0;
  padding: 0 0 0 .2rem;
  font-size: .28rem;
  color: #4625BB;
  background: none;
  border: none;
}
.max-btn:disabled {
  color: #A2A2A2;
}
.amount-error {
  margin: .1rem .1rem 0;
  color: #FF0000;
  font-size: .26rem;
}
.rule-line {
  margin: .1rem .1rem 0;
  color: #A2A2A2;
  font-size: .26rem;
}
.limit-alert {
  display: flex;
  align-items: center;
  gap: .1rem;
  margin-top: .2rem;
  padding: .2rem .24rem;
  border-radius: .1rem;
  background-color: #FCE0A4;
}
.limit-alert-icon {
  flex-shrink: 0;
  height: .3rem;
  width: auto;
}
.limit-alert-text {
  flex: 1;
  font-size: .26rem;
  color: #1B1B1D;
}
.limit-retry {
  flex-shrink: 0;
  padding: .06rem .16rem;
  font-size: .26rem;
  color: #4625BB;
  background: #D2D3FF;
  border: none;
  border-radius: .1rem;
}

.label-tips {
  margin-top: .1rem;
  padding: .1rem;
  background: #f7f6fc;
  border-radius: 0.1rem;
  color: #000000;
  display: flex;
}
.label-tips span {
  font-size: 0.26rem;
  color: #484554;
}
.add-tips {
  margin-top: .02rem;
  margin-left: .1rem;
  margin-right: .1rem;
  width: .26rem;
  height: .26rem;
}

.input-icon-email {
  height: .39rem;
  width: auto;
}

.del-icon {
  height: .3rem;
  width: auto;
}
.selectAddPaypalContainer {
  height: 1rem;
  padding: 0 0.2rem;
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: .2rem;
}
.select-account-right-2 {
  margin-right: .06rem;
  height: .36rem;
  width: auto;
}

.withdraw-form-item {
  display: flex;
  flex-direction: column;
  gap: .1rem;
  align-items: center;
  padding: 0 0.2rem;
  background-color: #EFF2F8;
  border-radius: .2rem;
}

.withdraw-form-icon {
  height: .7rem;
  width: auto;
}

.withdraw-form-label1 {
  display: flex;
  margin-top: .2rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: .2rem .4rem;
}
.withdraw-form-label-l {
  display: flex;
  gap: .2rem;
  align-items: center;
  margin-left: .2rem;
}

.withdraw-form-label1-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 .2rem;
}
.withdraw-form-label1-2 span {
  font-size: .32rem;
}
.green-right {
  height: .31rem;
  width: .39rem;
  margin-right: .2rem;
}
.form-line {
  height: .02rem;
  width: 100%;
  background-color: #D8D8D8;
  margin: 0.2rem;
}

.withdraw-form-a {
  display: flex;
  margin: .2rem 0;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.withdraw-form-a-1 {
  font-size: .26rem;
  color: #484554;
}

.withdraw-form-a-2 {
  font-size: .4rem;
  font-weight: bold;
}

.sec {
  display: flex;
  align-items: center;
  padding: .1rem .2rem;
  border-radius: .4rem;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  margin-bottom: .3rem;
  gap: .2rem;
  background-color: #f6f5f7;
}

.sec-icon {
  height: .3rem;
  width: auto;
}

.sec-span {
  color: #5D5E63;
  font-size: .22rem;
}

.upload-container {
  margin-top: .1rem;
  width: 2rem;
  height: 2rem;
  border: .01rem solid #E2E8F0;
  border-radius: 0.08rem;
  position: relative;
  cursor: pointer;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #94A3B8;
  font-size: 12px;
}

.upload-preview {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右上角删除按钮 */
.remove-btn {
  position: absolute;
  top: -.08rem;
  right: -.08rem;
  width: .16rem;
  height: .16rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.label-tips {
  margin-top: 16px;
}

/* ===== 横屏适配：内容已由 RotateFrame 旋转成竖屏，这里让页面铺满旋转框、保持竖屏布局 =====
   旋转后 100vw 才是「竖屏的高度」、100vh 是「竖屏的宽度」，抽屉高度因此改用 vw。 */
@media screen and (orientation: landscape) {
  .withdraw-root {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
    overflow-y: auto;
  }

  .drawer,
  .drawer-high {
    height: 60vw;
  }
  .drawer-body {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
